import { render, staticRenderFns } from "./CollectionAppointments.vue?vue&type=template&id=055ba615&scoped=true"
import script from "./CollectionAppointments.vue?vue&type=script&lang=js"
export * from "./CollectionAppointments.vue?vue&type=script&lang=js"
import style0 from "./CollectionAppointments.vue?vue&type=style&index=0&id=055ba615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ba615",
  null
  
)

export default component.exports